import axios, { AxiosError } from "axios";
import { useQuery, UseQueryResult } from "react-query";
import { EmployerODPResponse } from "../../@types/blockedDates";

export const GetEmployerODPLimitsApiService =
  async (): Promise<EmployerODPResponse> => {
    const url = `/odp_limits/config/`;
    const { data } = await axios.get<EmployerODPResponse>(url);
    return data;
  };

const useGetEmployerODPLimitsApiService = (): UseQueryResult<
  EmployerODPResponse,
  AxiosError
> =>
  useQuery<EmployerODPResponse, AxiosError>(
    ["GetEmployerODPLimitsApiService"],
    () => GetEmployerODPLimitsApiService(),
    { keepPreviousData: false }
  );

export default useGetEmployerODPLimitsApiService;
